import { render } from "./PriceTag.vue?vue&type=template&id=9318bcbe&scoped=true"
import script from "./PriceTag.vue?vue&type=script&lang=js"
export * from "./PriceTag.vue?vue&type=script&lang=js"

import "./PriceTag.vue?vue&type=style&index=0&id=9318bcbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9318bcbe"]])

export default __exports__